<!--
 * @Author: Cathy
 * @Date: 2020-02-24 10:00:48
 * @LastEditors: yezi
 * @LastEditTime: 2020-07-16 16:41:33
 * @Description: 联吧下载
 -->
<template>
 <div class="download" @scroll.passive="scroll($event)">
    <topMenu pageType="recommend" />
    <isWeixinMark :isWeixin="isWeixin" @onCancelMark="isWeixin=false" />
    <div class="downloadImage" @click="onDownload">
        <img src="../assets/images/xiazai_duan.png" />
    </div>
 </div>
</template>

<script>
import topMenu from '../components/topMenu'
import isWeixinMark from '../components/isWeixinMark'
import { getList } from '../api/wap'
export default {
  name: 'download',
  components: {
    topMenu,
    isWeixinMark
  },
  data () {
    return {
      downloadLink: '',
      isWeixin: false
    }
  },
  created () {
    this.onLoadData()
  },
  methods: {
    onLoadData () {
      getList({ type: 1 })
        .then(res => {
          this.downloadLink = res.result.download_url.android
        })
    },
    onDownload () {
      const u = window.navigator.userAgent
      const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
      const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      if (isIos) {
        // location.href = 'https://apps.apple.com/cn/app/%E8%81%94%E5%90%A7/id1404140841'
        location.href = 'https://apps.apple.com/us/app/lianba/id1567178771'
      }
      if (isAndroid) {
        this.isWeixin = u.toLowerCase().indexOf('micromessenger') !== -1
        if (!this.isWeixin) {
          location.href = this.downloadLink
        }
      }
    },
    scroll (e) {
      console.log(e)
    }
  }
}
</script>

<style scoped>
.downloadImage {
    margin-top: 1rem;
    text-align: center;
}
.downloadImage img{
    width: 6.5rem;
    height: 1.4rem;
}
</style>
